module.exports = __webpack_public_path__ + "static/media/outfit-gucci.c466038b.jpg";